import { z } from 'zod';

export const supportFeedbackSchema = z.object({
  kind: z.enum(['bug', 'feature', 'question']),
  message: z.string().trim().min(10).max(2000),
  page: z.string().max(300).optional(),
});

export type SupportFeedbackInput = z.infer<typeof supportFeedbackSchema>;
